const envApiBase = process.env.REACT_APP_API_BASE_URL || "";
const rawBase = envApiBase || (typeof window !== "undefined" ? window.location.origin : "");

export const API_BASE = rawBase.replace(/\/+$/, "");

export const STAFF_SESSION_TOKEN = "__staff_cookie_session__";
export const CLIENT_SESSION_TOKEN = "__client_cookie_session__";

export function isSessionToken(token) {
  return token === STAFF_SESSION_TOKEN || token === CLIENT_SESSION_TOKEN;
}

export function hasUsableToken(token) {
  return Boolean(token) && !isSessionToken(token);
}

export function buildAuthHeaders(token, extraHeaders = {}) {
  if (!hasUsableToken(token)) {
    return { ...extraHeaders };
  }
  return {
    ...extraHeaders,
    Authorization: `Bearer ${token}`,
  };
}

export function resolveApiUrl(value) {
  const rawValue = String(value || "").trim();
  if (!rawValue) return API_BASE;

  if (/^https?:\/\/(127\.0\.0\.1|localhost):8000/i.test(rawValue)) {
    return rawValue.replace(/^https?:\/\/(127\.0\.0\.1|localhost):8000/i, API_BASE);
  }

  if (/^https?:\/\//i.test(rawValue)) {
    return rawValue;
  }

  if (!API_BASE) {
    return rawValue;
  }

  if (rawValue.startsWith("/")) {
    return `${API_BASE}${rawValue}`;
  }

  return `${API_BASE}/${rawValue}`;
}
